module.exports = __webpack_public_path__ + "img/logo_hw.10842224.png";